module.exports = __webpack_public_path__ + "img/collaborate_22.84203322.jpg";